// extracted by mini-css-extract-plugin
module.exports =  {"checkbox":"_0d624b9a27--checkbox--l9NIC","label":"_0d624b9a27--label--wg3E4","box":"_0d624b9a27--box--LEKeq","hasLabel":"_0d624b9a27--hasLabel--uSvdq"};